'use strict';

/*
 created by lvs 2018-8-2
 */
angular.module('newspaperAwaitReviseModule', []).controller('newspaperAwaitReviseCtrl', [
    '$scope',
    'editNewspaperService',
    '$q',
    'trsHttpService',
    'initSingleSelecet',
    'modalDialog',
    'editcenterRightsService',
    'trsspliceString',
    'editingCenterService',
    'storageListenerService',
    'globleParamsSet',
    'localStorageService',
    '$state',
    '$window',
    'websiteService',
    'editingCenterAppService',
    'qiehaoService',
    'baijiahaoService',
    'toutiaohaoService',
    'messagePublishService',
    function(
        $scope,
        editNewspaperService,
        $q,
        trsHttpService,
        initSingleSelecet,
        modalDialog,
        editcenterRightsService,
        trsspliceString,
        editingCenterService,
        storageListenerService,
        globleParamsSet,
        localStorageService,
        $state,
        $window,
        websiteService,
        editingCenterAppService,
        qiehaoService,
        baijiahaoService,
        toutiaohaoService,
        messagePublishService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.esparams = {};// es检索参数
            $scope.data = {
                selectedArray: [],
                dxdList: [],
                items: [],
                newspaperPreview: editNewspaperService.initNewspaperPreview(),
            };
            // 这个事为了适应海贝检索的指令
            $scope.params = {
                docType: '', 
                docstatus: ''
            };
            $scope.status = {
                mediaType: -4,
                status_model: '',
                isEsSearch: false, // 判断是否是经过ES检索之后 
                copyCurrPage: 1,
                params: {
                    serviceid: 'mlf_modifydoc',
                    // 新媒体接口参数不一样
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    methodname: 'queryNewMediaModifyDocsByUser',
                    isLoadAllMediaType: 1,
                },
                cachedName: 'newspaperAwaitRevise',
                cachedPage: {},
                cacheOpenedPanel: {},
                openedPanel: {
                    0: true,
                },
                editPath: {
                    '1': editingCenterAppService.initEditPath(),
                    '2': websiteService.getEditandPreviewPath().edit,
                    '3': editNewspaperService.initNewspaperEdit(),
                    '4': {
                        1: 'wxeditpage',
                    },
                    '5': {
                        16: 'weiboedit',
                        17: 'weiboheadlinesedit'
                    },
                    '17': {
                        7: 'trillnews', // 抖音都是视频稿
                    },
                    '18': baijiahaoService.initEditPath(), // 百家号编辑页路径
                    '19': qiehaoService.initEditPath(), // 企鹅号编辑页路径
                    '20': toutiaohaoService.initEditPath(), // 头条号编辑路径
                    '25': {
                        7: 'kuaishoudraft'
                    }
                },
                newspaperModuleType: {
                    jrgedit: 1,
                    jrgpreview: 1,
                    dygedit: 0,
                    dygpreview: 0,
                    sbgpreview: 2,
                    sbgedit: 2,
                },
                isAwaitRevise: 'isAwaitRevise', // true
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            // 依据初始化按钮
            editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function(rights) {
                $scope.status.btnRights = rights;
            });
            listenNewMediaStorage();
            requestData();
            initDropDown();
            refreshList();
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function (event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    }
                    // 暂时的其他情况是boolean
                    else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {};
            if ($scope.status.isEsSearch) {
                params = $scope.esparams;
                params.searchParams.PAGEINDEX = $scope.page.CURRPAGE;
            } else {
                params = $scope.status.params;
            }
            !$scope.status.keywords ? delete params.KeyWords : (params.KeyWords = $scope.status.keywords);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                var ListItems = data.DATA;
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                listItemCache(ListItems);
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(
                    function(data) {
                        angular.forEach(ListItems, function(value, key) {
                            value.ALLIMG = data[value.PAPERMODIFYDOCID];
                            if (data[value.PAPERMODIFYDOCID]) {
                                value.METALOGOURL = data[value.PAPERMODIFYDOCID][0];
                            }
                        });
                        $scope.data.items = ListItems;
                    },
                    function(data) {
                        $scope.data.items = ListItems;
                    }
                );

                $scope.$emit('getTrsHeight');
            });
        }

        /**
         * [requestListImg description]查询列表图示
         *
         * @param   {[type]}  items  [items description]
         *
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_modifydoc',
                    methodname: 'queryAllImgLogo',
                    paperModifyDocIds: trsspliceString.spliceString(items, 'PAPERMODIFYDOCID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        defer.resolve(data);
                    },
                    function() {
                        defer.reject();
                    }
                );
            }
            return defer.promise;
        }

        /**
         * [newspaperPreview description]报纸预览
         *
         * @param   {[type]}  item  [item description]当前对象
         *
         * @return  {[type]}        [return description]
         */
        $scope.routerToPreview = function(item) {
            editingCenterService.routerToPreview(item, {
                isawaitrevise: 'waitingRevise',
                newspapertype: item.STATUS
            });
        };

        /**
         * [initDropDown description]初始化下拉框
         * @return {[type]} [description]
         */
        function initDropDown() {
            // 初始化选择类型
            $scope.data.docTypeArray = initSingleSelecet.newspaperDraftType();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
            // 初始化选择状态
            $scope.data.todayManuStatusArray = initSingleSelecet.todayManuStatus();
            $scope.data.SelectedTodayManuStatus = angular.copy($scope.data.todayManuStatusArray[0]);
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
            $scope.data.conditionsSearch = initSingleSelecet.newspaperEntire();
            $scope.data.selectedConditions = angular.copy(initSingleSelecet.newspaperEntire()[0]);
        }

        // /**
        //  * [listenStorage description]监听本地缓存
        //  * @return {[promise]} [description] promise
        //  */
        // function listenStorage() {
        //     storageListenerService.listenNewspaper(function() {
        //         requestData();
        //         storageListenerService.removeListener('newspaper');
        //     }, $scope);
        //     storageListenerService.listenWebsite(function() {
        //         requestData();
        //         storageListenerService.removeListener('website');
        //     }, $scope);
        //     storageListenerService.listenApp(function() {
        //         requestData();
        //         storageListenerService.removeListener('app');
        //     }, $scope);
        //     storageListenerService.listenWeixin(function() {
        //         requestData();
        //         storageListenerService.removeListener('weixin');
        //     }, $scope);
        //     $scope.$on('$destroy', function() {
        //         localStorageService.remove('newspaperPreviewSelectArray');
        //         localStorageService.remove('newspaperPreviewCache');
        //     });
        // }

        /**
         * [listenNewMediaStorage description]监听新媒体渠道的缓存
         * @return{[type]}[return description]
         */
        function listenNewMediaStorage() {
            $scope.status.isEsSearch = false;
            storageListenerService.listenToWeibo(function() {
                requestData();
                storageListenerService.removeListener('weibo');
            }, $scope);
            storageListenerService.listenQiehao(function() {
                requestData();
                storageListenerService.removeListener('qiehao');
            }, $scope);
            storageListenerService.listenToutiaohao(function() {
                requestData();
                storageListenerService.removeListener('toutiaohao');
            }, $scope);
            storageListenerService.listenBaijiahao(function() {
                requestData();
                storageListenerService.removeListener('baijiahao');
            }, $scope);
            storageListenerService.listenTrill(function() {
                requestData();
                storageListenerService.removeListener('trill');
            }, $scope);
            storageListenerService.listenNewspaper(function() {
                requestData();
                storageListenerService.removeListener('newspaper');
            }, $scope);
            storageListenerService.listenWebsite(function() {
                requestData();
                storageListenerService.removeListener('website');
            }, $scope);
            storageListenerService.listenApp(function() {
                requestData();
                storageListenerService.removeListener('app');
            }, $scope);
            storageListenerService.listenWeixin(function() {
                requestData();
                storageListenerService.removeListener('weixin');
            }, $scope);
            $scope.$on('$destroy', function() {
                localStorageService.remove('newspaperPreviewSelectArray');
                localStorageService.remove('newspaperPreviewCache');
            });
        }

        // 监听预览页 按钮点击
        $window.addEventListener('storage', function(e) {
            // arc
            $scope.data.selectedCurrents = angular.copy(localStorageService.get('newspaperPreviewSelectArray')); // page
            $scope.$apply(function() {
                selectCurArray($scope.data.selectedCurrents);
            });
        });

        /**
         * [listItemCache description]缓存存储
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function listItemCache(data) {
            var cachePreviewMetadataid = [];
            $scope.data.selectedArrayObj = [];
            cachePreviewMetadataid = data.map(function(value, key) {
                $scope.data.selectedArrayObj.push(value);
                return {
                    NEWSPAPERTYPE: value.NEWSPAPERTYPE,
                    METADATAID: value.METADATAID,
                };
            });
            localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
        }

        /**
         * [selectedArrayCahe description]缓存当前选中项
         *
         * @param   {[type]}  array  [array description]选中对象
         *
         * @return  {[type]}         [return description]
         */
        function selectedArrayCahe(array) {
            var selectedArray = angular.copy(array);
            var selectedArrayMetadaid = [];
            angular.forEach(selectedArray, function(data, index) {
                selectedArrayMetadaid.push(data.METADATAID);
            });
            localStorageService.set('newspaperPreviewSelectArray', selectedArrayMetadaid); // paged
        }

        /**
         * [selectCurArray description]遍历出选择对象
         *
         * @param   {[type]}  curSelectedArray  [curSelectedArray description]当前选中对象
         *
         * @return  {[type]}                    [return description]
         */
        function selectCurArray(curSelectedArray) {
            if (curSelectedArray == null) {
                return;
            } else {
                $scope.data.selectedArray = [];
                for (var i = 0; i < curSelectedArray.length; i++) {
                    for (var j = 0; j < $scope.data.selectedArrayObj.length; j++) {
                        if (curSelectedArray[i] === $scope.data.selectedArrayObj[j].METADATAID) {
                            $scope.data.selectedArray.push($scope.data.selectedArrayObj[j]);
                        }
                    }
                }
            }
            // var arrays=[];
        }

        /**
         * [handlerEditParams description]处理编辑页传参
         *
         * @param   {[type]}  item  [item description]稿件对象
         *
         * @return  {[type]}        [return description]
         */
        function handlerEditParams(item) {
            var editParams;
            if (item.MEDIATYPE == '3') {
                // 纸媒
                editParams = {
                    papermetadataid: item.METADATAID,
                    paperid: item.SITEID,
                    newspapertype: item.NEWSPAPERTYPE,
                    isawaitrevise: 'isAwaitRevise',
                };
            } else if (item.MEDIATYPE == '2') {
                // 网站
                editParams = {
                    wzchannelid: item.CHANNELID,
                    wzchnldocid: item.CHNLDOCID,
                    wzmetadataid: item.METADATAID,
                    wzsiteid: item.SITEID,
                    wzplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                };
            } else if (item.MEDIATYPE == '1') {
                // app
                editParams = {
                    appchannelid: item.CHANNELID,
                    appchnldocid: item.CHNLDOCID,
                    appmetadataid: item.METADATAID,
                    appsiteid: item.SITEID,
                    appplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                };
            } else if (item.MEDIATYPE == '4') {
                // 微信渠道
                editParams = {
                    wxplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    wxchannelid: item.CHANNELID,
                    wxmetadataid: item.METADATAID,
                    wxchnldocid: item.CHNLDOCID,
                };
            } else if (item.MEDIATYPE == '5') {
                // 微博渠道
                editParams = {
                    wbplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    wbchannelid: item.ACCOUNTID,
                    wbmetadataid: item.NEWDOCID,
                };
            } else if (item.MEDIATYPE == '19') {
                // 企鹅渠道
                editParams = {
                    qiehaoplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    qiehaoarticleid: item.NEWDOCID,
                    qiehaoaccount: item.ACCOUNTID,
                };
            } else if (item.MEDIATYPE == '17') {
                // 抖音渠道
                editParams = {
                    platform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    douyinarticleid: item.NEWDOCID,
                    accountid: item.ACCOUNTID,
                };
            } else if (item.MEDIATYPE == '18') {
                // 百家号渠道
                editParams = {
                    baijiahaoplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    baijiahaoarticleid: item.NEWDOCID,
                    baijiahaoaccount: item.ACCOUNTID,
                };
            } else if (item.MEDIATYPE == '20') {
                // 头条号渠道
                editParams = {
                    toutiaohaoplatform: item.DOCSTATUS == 1 ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    articleid: item.NEWDOCID,
                    account: item.ACCOUNTID,
                };
            } else if (item.MEDIATYPE === '25') {
                editParams = {
                    platform: item.DOCSTATUS === '1' ? 0 : 1,
                    isawaitrevise: 'isAwaitRevise',
                    articleid: item.NEWDOCID,
                    accountid: item.ACCOUNTID,
                };
            }
            return editParams;
        }

        /**
         * [isLockEdit description]编辑前请求解锁
         * @param   {[type]}  item  [item description]稿件对象
         * @return  {[type]}        [return description]
         */
        $scope.routerToEdit = function(item) {
            var editParams = handlerEditParams(item);
            var editUrl = $state.href($scope.status.editPath[item.MEDIATYPE][item.DOCTYPEID], editParams);
            $window.open(editUrl);
        };

        /**
         * [showVersionTime description]流程版本时间与操作日志
         *
         * @param   {[type]}  item  [item description]稿件对象
         *
         * @return  {[type]}        [return description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, true);
        };

        /**
         * [fullTextSearch description]全文检索
         *
         * @param   {[type]}  ev  [ev description]按下空格也能提交
         *
         * @return  {[type]}      [return description]
         */
        // $scope.fullTextSearch = function(ev) {
        //     if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
        //         $scope.status.isESSearch = true;
        //         $scope.page.CURRPAGE = 1;
        //         requestData();
        //     }
        // };
        $scope.selectTime = function() {
            $scope.status.params.OprTimeStart = $scope.data.fromdate;
            $scope.status.params.OprTimeEnd = $scope.data.untildate;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [queryItemsByDropDown description]点击下拉框查询列表
         *
         * @param   {[type]}  key    [key description]类型
         * @param   {[type]}  value  [value description]请求参数
         *
         * @return  {[type]}         [return description]
         */
        $scope.queryItemsByDropDown = function(key, value) {
            $scope.status.params[key] = value;
            if (key == 'oprtime') {
                if (value.length < 10) {
                    $scope.status.params.OprTimeStart = null;
                    $scope.status.params.OprTimeEnd = null;
                } else {
                    $scope.status.params.OprTimeStart = $scope.data.fromdate;
                    $scope.status.params.OprTimeEnd = $scope.data.untildate;
                    $scope.status.params[key] = null;
                }
            }
            requestData();
        };

        /**
         * [revisionCompleted description]修订完成
         * @return {[type]} [description]
         */
        $scope.revisionCompleted = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('操作失败', '每次只能修订一篇稿件', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_modifydoc',
                methodname: 'newMediaModifyDocsFinished',
                NewDocId: $scope.data.selectedArray[0].NEWDOCID,
                MediaType: $scope.data.selectedArray[0].MEDIATYPE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.multiReportsAlert(data, function() {
                    requestData();
                });
                // if (data.ISSUCCESS == 'true') {
                // }
            });
        };

        /**
         * [selectDoc description]单选列表
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
            selectedArrayCahe($scope.data.selectedArray);
        };

        /**
         * [cancelBatchOperate description]取消批量操作的样式
         * @return {[type]} [description] null
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    hoverStatus: '',
                    clickStatus: '',
                };
            }
        }

        /**
         * [selectAll description]全选列表
         * @return {[type]} [description] null
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
            selectedArrayCahe($scope.data.selectedArray);
        };

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.status.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.status.params[key] = value;
            $scope.status.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            if (key == 'OperTime') {
                $scope.status.params.OperTimeStart = $scope.data.fromdate;
                $scope.status.params.OperTimeEnd = $scope.data.untildate;
                $scope.status.params[key] = null;
            }
            requestData();
        };
    },
]);
